export default "__VITE_ASSET__G3luUeA4rGgntTUDGl$SsA__"